'use strict';

import React from 'react';
import ReactDom from 'react-dom';
import PubSub from 'pubsub-js';

import DetectorComponent from './DetectorComponent';
import CircleType from 'circletype';
import animations from '../../animations/animations';

//require('styles//Smile.css');

class SmileComponent extends React.Component {
	constructor(props){
		super(props);

		this.dom = {}
		this.state = {
			emotion: "",
			emotionValue: 0.45,
			message: "Smile! ",
			radius: 900,
			isHidden: false
		};

		this.circleType = null;
	}

	componentWillEnter(cb){
		animations.show(this.dom.root, cb);
	}

	componentDidMount(){
		this.dom.root = ReactDom.findDOMNode(this);
		
		this.circleType = new CircleType(document.getElementById('smile-component'));
		this.updateCircleText(1)
//return
		var token = PubSub.subscribe('EMOTION', (e,d) => {
			//console.log(d)
			var emoji = d.value > 0.5 ? ":)" : ":("
			this.setState({
				emotion: emoji,
				emotionValue: d.value.toFixed(4)
			})
//console.log(d.value, d.value*1000)
			if(d.value > 0.5){
				this.updateCircleText(-1)
				
				PubSub.unsubscribe(token);
				
				PubSub.publish('CAMERA_STOP')
				setTimeout(() => {
					animations.zoomOut(this.dom.root, () => {
						this.setState({
							isHidden: true
						})
						PubSub.publish('DID_SMILE')
					});
				}, 500);
			
			}else{
				this.updateCircleText(1)

			}
		})
	}

	updateCircleText(dir){
		let radius
		if(dir<0)radius = this.state.radius - (100 + (this.state.emotionValue * 100) * 500 / 100)
		if(dir>0)radius = (500 + (this.state.emotionValue * 100) * 500 / 100)
		
		//console.log(this.state.emotionValue * 100, radius)
		//this.circleType.radius(this.state.radius).dir(dir);
		this.circleType.radius(radius).dir(dir);
	}

	render() {
		let smileWrapStyle = {
			background: this.state.emotionValue>=0.5 ? "#ffffcc" : "#fff"
		}
		let jaugeStyle = {
			height: (this.state.emotionValue * 100)+"%"
		}
		if(this.state.isHidden){
			return (
				<div></div>
			)
		}else{
			return (
				<div className="overlay">
					<div id="smile-wrap" style={smileWrapStyle}>
						<div className="inner">
							<div className="eyes">
								<div className="eye">
									<div>{this.state.message}</div>
									<div>{this.state.message} {this.state.message}</div>
								</div>
								<div className="eye">
									<div>Smile!</div>
									<div>{this.state.message} {this.state.message}</div>
								</div>
							</div>
							<div className="noze">
								<div>{this.state.message}</div>
								<div>{this.state.message} {this.state.message}</div>
							</div>
							<div id="smile-component">
								{this.state.message} {this.state.message} {this.state.message} {this.state.message} {this.state.message} {this.state.message}
							</div>
							
							
							<div className="jauge" style={jaugeStyle}>
								<div className="value">
									{Math.round(this.state.emotionValue * 100)}%
								</div>
								<div className="emotion">
									{this.state.emotion}
								</div>
							</div>
						</div>
						<DetectorComponent />
					</div>
				</div>
			);
		}
		
	}
}

SmileComponent.displayName = 'SmileComponent';

// Uncomment properties you need
// SmileComponent.propTypes = {};
// SmileComponent.defaultProps = {};

export default SmileComponent;



// WEBPACK FOOTER //
// ./src/components/smile-detector/SmileComponent.js